/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierResolverAddRecordRequest
 */
export interface CourierResolverAddRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierResolverAddRecordRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the CourierResolverAddRecordRequest interface.
 */
export function instanceOfCourierResolverAddRecordRequest(value: object): value is CourierResolverAddRecordRequest {
    return true;
}

export function CourierResolverAddRecordRequestFromJSON(json: any): CourierResolverAddRecordRequest {
    return CourierResolverAddRecordRequestFromJSONTyped(json, false);
}

export function CourierResolverAddRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierResolverAddRecordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CourierResolverAddRecordRequestToJSON(json: any): CourierResolverAddRecordRequest {
    return CourierResolverAddRecordRequestToJSONTyped(json, false);
}

export function CourierResolverAddRecordRequestToJSONTyped(value?: CourierResolverAddRecordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

